<template>
	<div class="category">
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/pages/shop/category/category.vue